import { SiteSettingsModel } from "src/app/api/api-types";
import { EditSiteModel } from "src/app/partner/shared/edit-site.model";
import { getApiDetailsDecorator } from "src/utils";
import { OnComplexSettings } from "./on-complex/on-complex-settings.model";
import { SitePreferences } from "./site-preferences.model";
import { SpotTruckInspectionSettings } from "./spot-truck-inspection/spot-truck-inspection.model";

const api = getApiDetailsDecorator<SiteSettingsModel>();

export class SiteSettings {
  public constructor(args: ClassProperties<SiteSettings>) {
    this.generalSettings = args.generalSettings;
    this.isDropTrailerListHidden = args.isDropTrailerListHidden;
    this.onComplexSettings = args.onComplexSettings;
    this.sitePreferences = args.sitePreferences;
    this.spotTruckInspectionSettings = args.spotTruckInspectionSettings;
  }

  @api() public readonly onComplexSettings: OnComplexSettings;
  @api() public readonly sitePreferences: SitePreferences;
  @api()
  public readonly spotTruckInspectionSettings: SpotTruckInspectionSettings;
  @api({ key: "hideDropTrailerList" })
  public readonly isDropTrailerListHidden: boolean;
  @api({ key: "siteGeneralSettings" })
  public readonly generalSettings: EditSiteModel;

  public static deserialize(data: SiteSettingsModel): SiteSettings {
    return new SiteSettings({
      isDropTrailerListHidden: data.hideDropTrailerList,
      onComplexSettings: new OnComplexSettings(data.onComplexSettings),
      sitePreferences: SitePreferences.deserialize({
        sitePreferences: data.sitePreferences,
        hideDropTrailerList: data.hideDropTrailerList,
        onComplexSettings: data.onComplexSettings,
      }),
      spotTruckInspectionSettings: SpotTruckInspectionSettings.deserialize(
        data.spotTruckInspectionSettings,
      ),
      generalSettings: EditSiteModel.deserialize({
        ...data.siteGeneralSettings,
        ...data.siteInfo,
      }),
    });
  }
}
